import { render } from "./WeeklyBookingPage.vue?vue&type=template&id=4a04b0c2&scoped=true"
import script from "./WeeklyBookingPage.vue?vue&type=script&lang=js"
export * from "./WeeklyBookingPage.vue?vue&type=script&lang=js"

import "./WeeklyBookingPage.vue?vue&type=style&index=0&id=4a04b0c2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc07\\Documents\\GitHub\\lezione-online-test\\gatthotel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a04b0c2"]])

export default __exports__